import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { Link, Outlet } from 'react-router-dom';
import alphfabet from "../../assets/images/englishAlphabet.png";
import imageForGame2 from "../../assets/images/abcd_game2.jpg";

const useStyles = makeStyles((theme) => ({
  root: {
    display:"flex",
    flexDirection:"row",
    flexGrow: 1,
      justifyContent:"space-around",
  },
  paper: {
    padding: theme.spacing(1),
    width:'40em',
      height: '40em',
    textAlign: "center",
    color: theme.palette.text.secondary,
    backgroundColor: "grey",
    backgroundImage:`url(${alphfabet})`,
    backgroundRepeat: "round",
  },
    paper2: {
        padding: theme.spacing(1),
        width:'40em',
        height: '40em',
        textAlign: "center",
        color: theme.palette.text.secondary,
        backgroundColor: "grey",
        backgroundImage:`url(${imageForGame2})`,
        backgroundRepeat: "round",
    }
}));

export default function NestedGrid() {
  const classes = useStyles();

  return (
      <>
          <h3> Games</h3>
          <div className={classes.root} >
              <Link
                  style={{ display: 'block', margin: '1rem 0' }}
                  to={`/games/english-letter-pronunciation`}
                  key={'english-letter-pronunciation'}
              >
                  <Paper className={classes.paper}>Check letter</Paper>
              </Link>
              <Link
                  style={{ display: 'block', margin: '1rem 0' }}
                  to={`/games/english-letter-hidden`}
                  key={'game2'}
              >
                  <Paper className={classes.paper2}>Check letter</Paper>
              </Link>
              <Outlet />
          </div>
      </>

  );
}
